<template>
    <tr class="row">
        <td v-if="$vuetify.breakpoint.smAndDown">{{ combinedClassificationAndType }}</td>
        <td v-if="!$vuetify.breakpoint.smAndDown">{{ pestConfiguration.PestClassification }}</td>        
        <td v-if="!$vuetify.breakpoint.smAndDown">{{ pestConfiguration.PestClassificationType }}</td>
        <td>{{ pestConfiguration.Name }}</td>
        <td>
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn
                    style="width:0;margin:0"
                    color="accent"                    
                    v-on="on"
                    small
                    >
                    {{ size || 'N/A' }}
                    </v-btn>
                </template>
                <v-list>
                    <v-list-tile
                    v-for="(classification, index) in classificationSizes"
                    :key="index"
                    @click="sizeChanged(classification)"
                    >
                    <v-list-tile-title>{{ classification }}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>                                
        </td>
        <td>
            <v-layout v-if="pestConfiguration.ScoutingScoreScale" align-center fill-height style="width: 187px !important;">
                <v-flex shrink>
                    <v-btn style="min-width:0;margin:3px" color="accent" icon @click="observationDecrease"><v-icon>chevron_left</v-icon></v-btn>
                </v-flex>                                    
                <v-flex shrink>
                    <v-text-field                                            
                        class="pl-0 pr-0"                                            
                        :value="observation ? observation : 0"
                        label="Score"
                        @input="observationChanged"
                        >
                    </v-text-field>
                </v-flex>                                    
                <v-flex shrink>
                    <v-btn style="min-width:0;margin:3px" color="accent" icon  @click="observationIncrease"><v-icon>chevron_right</v-icon></v-btn>
                </v-flex>
            </v-layout>
            <v-alert v-else color="error" :value="true">No Scale Configured</v-alert>
        </td>
        <td>
            <v-layout align-center fill-height>
                <v-flex shrink>
                    <v-btn style="min-width:0" class="ml-0 mr-1" :color="(notes || '') == '' ? 'accent' : 'primary'" @click="showNotes" icon><v-icon>insert_comment</v-icon></v-btn>
                </v-flex>                                    
                <v-flex shrink>
                    <v-btn style="min-width:0" class="ml-0 mr-1" color="accent" icon @click="showImages"><v-icon>panorama</v-icon></v-btn>
                </v-flex>                                    
                <v-flex shrink>
                    <v-btn style="min-width:0" class="ml-0 mr-0" color="accent" @click="showGPS" icon><v-icon>add_location</v-icon></v-btn>
                </v-flex>
            </v-layout>
        </td>
        <ScoutSpotCheckObservationGPSDialog v-if="gpsDialog" :dialog="gpsDialog" :gps="gps" @close="gpsDialog=false" @save="gpsChanged" :locationID="this.locationID"></ScoutSpotCheckObservationGPSDialog>
        <ScoutSpotCheckObservationNotesDialog v-if="notesDialog" :dialog="notesDialog" :notes="notes" @close="notesDialog=false" @save="notesChanged"></ScoutSpotCheckObservationNotesDialog>
        <ScoutSpotCheckObservationImagesDialog v-if="imageDialog" :dialog="imageDialog" :images="pestConfiguration.Images" :imageAuthToken="imageAuthToken" @close="imageDialog=false"></ScoutSpotCheckObservationImagesDialog>
    </tr>    
</template>
<script>
import ScoutSpotCheckObservationGPSDialog from '@/components/scout/ScoutSpotCheckObservationGPSDialog.vue';
import ScoutSpotCheckObservationNotesDialog  from '@/components/scout/ScoutSpotCheckObservationNotesDialog.vue';
import ScoutSpotCheckObservationImagesDialog from '@/components/scout/ScoutSpotCheckObservationImagesDialog.vue';

export default {
    components: {
        ScoutSpotCheckObservationGPSDialog,
        ScoutSpotCheckObservationNotesDialog,
        ScoutSpotCheckObservationImagesDialog
    },
    props: [
        "imageAuthToken",
        "pestConfiguration",
        "collapsed",
        "observation",
        "time",
        "notes",
        "otherName",
        "size",
        "latitude",
        "longitude",
        "locationID",
    ],
    data() {
        return {
            gpsDialog: false,
            notesDialog: false,
            imageDialog: false,
            gps: {
                latitude: this.latitude,
                longitude: this.longitude
            },
            classificationSizes: ["Small", "Medium", "Large"],
        }
    },
    computed: {
        combinedClassificationAndType() {
            let description = this.pestConfiguration.PestClassification;

            if(this.pestConfiguration.PestClassificationType) {
                description += '/' + this.pestConfiguration.PestClassificationType;
            }

            return description;
        }
    },
    methods: {
        observationDecrease() {
            let observationNumber = this.observation != null ? parseFloat(this.observation) : 0;
            let newVal = Math.round((observationNumber - this.pestConfiguration.ScoutingScoreScale.Interval) * 100) / 100;
            
            this.observationChanged(Math.max(newVal, this.pestConfiguration.ScoutingScoreScale.Minimum));
        },
        observationIncrease() {
            let observationNumber = this.observation != null ? parseFloat(this.observation) : 0;
            let newVal =  Math.round((observationNumber + this.pestConfiguration.ScoutingScoreScale.Interval) * 100) / 100;

            this.observationChanged(Math.min(newVal, this.pestConfiguration.ScoutingScoreScale.Maximum));
        },
        observationChanged(newVal) {
            if (newVal != null && newVal != 0) {
                if (isNaN(newVal)) {
                    newVal = 0;
                }

                if (newVal < this.pestConfiguration.ScoutingScoreScale.Minimum) {
                    newVal = this.pestConfiguration.ScoutingScoreScale.Minimum;
                }

                if (newVal > this.pestConfiguration.ScoutingScoreScale.Maximum) {
                    newVal = this.pestConfiguration.ScoutingScoreScale.Maximum;
                }
            }

            let event = {
                observation: newVal,
                pestConfigurationID: this.pestConfiguration.PestConfigurationID
            };

            this.$emit("onObservationChanged", event);
        },        
        showGPS() {
            this.gps = { 
                latitude: this.latitude,
                longitude: this.longitude
            }

            this.gpsDialog = true;
        },
        showNotes() {
            this.notesDialog = true;
        },
        showImages() {
            this.imageDialog = true;
        },
        sizeChanged(newVal) {
            let event = {
                size: newVal,
                pestConfigurationID: this.pestConfiguration.PestConfigurationID
            };

            this.$emit("onSizeChanged", event);
        },
        gpsChanged(newVal) {            
            let event = {
                gps: newVal,
                pestConfigurationID: this.pestConfiguration.PestConfigurationID
            };

            this.$emit("onGPSChanged", event);
            this.gpsDialog = false;
        },
        notesChanged(newVal) {
            let event = {
                notes: newVal,
                pestConfigurationID: this.pestConfiguration.PestConfigurationID
            };

            this.$emit("onNotesChanged", event);
            this.notesDialog = false;
        }
    }
}
</script>
<style scoped>
.row td {
   padding-left: 2px !important;
   padding-right: 2px !important;
}
</style>